(function (app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTracker.Plans.CollegePlan",
                    {
                        url: "/CollegePlan/{collegePlanId}",
                        component: "collegeplan",
                        PageTitle: "Marketing Tracker - College Plan",
                        resolve: {
                            collegePlanDocument: ["$stateParams", "marketingPlanApi", "marketingTrackerAgent",
                                function ($stateParams, marketingPlanApi, marketingTrackerAgent) {
                                    return marketingPlanApi
                                        .getCollegePlanDocument(marketingTrackerAgent.AgentId, $stateParams.collegePlanId)
                                        .then(function (file) {
                                            return URL.createObjectURL(file);
                                        });
                                }]
                        }
                    });
        }
    ]);

    app.component("collegeplan",
        {
            templateUrl: "App/Tools/MarketingTracker/Plans/CollegePlan/collegeplan-template.html",
            controller: collegePlanController,
            bindings: {
                collegePlanDocument: "<"
            }
        });

    collegePlanController.$inject = ["$scope"];
    function collegePlanController($scope) {
        var $ctrl = this;

        $scope.$on("$destroy",
            function () {
                if ($ctrl.collegePlanDocument)
                    URL.revokeObjectURL($ctrl.collegePlanDocument);
            });
    }

})(window.app);